<div>
  <mat-checkbox [(ngModel)]="withSticker" (ngModelChange)="withStickerChanged()"
    ><span class="strong">Ineens met sticker op bord</span>
    <span *ngIf="ipBoard.leftRightBoard" class="side-label">{{ label }}</span>
    (Verkocht/Verhuurd/Verlaagde prijs/Nieuwe voorwaarden)</mat-checkbox
  >
</div>

<ng-container *ngIf="withSticker">
  <mat-card class="top-card mat-elevation-z0">
    <mat-form-field appearance="outline">
      <input
        matInput
        placeholder="Gewenste sticker"
        [(ngModel)]="ipBoardPart.otherSticker"
        (ngModelChange)="save.emit()"
      />
    </mat-form-field>
  </mat-card>
</ng-container>
